import React from 'react'
import backbarStyle from './BackBar.module.css'
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

export default function BackBar() {
  const navigate = useNavigate();

  return (
    <>
    <div className={`${backbarStyle.backbarComponent} d-flex flex-wrap align-items-center`}>
        <h5 className={`${backbarStyle.backbarTitle} d-flex me-auto m-0`}>
            <a href="#" onClick={(e) => {e.preventDefault();navigate(-1);}} > <span className={backbarStyle.backiconStyle}><FaArrowLeft className='me-2'/></span>Back</a>
        </h5>                    
    </div>
    </>
  )
}
